const jQ = jQuery.noConflict();

class InView {
    constructor({ customClass, customItem }) {
        this.customClass = customClass;
        this.customItem = customItem;
    }
    customInit() {
        jQ(this.customItem).one('inview', InView.customItem(jQ(this.customItem), this.customClass));
    }

    static customItem(el, customClass) {
        el.addClass(customClass);
    }
}

export default InView;
